import { Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { DrFileMetaCategoryList } from '@app/shared/models/dr-file';
import { FileType } from '@app/shared/models/file-type';
import { CaseFileCategories, CaseFileCategory } from '@app/shared/models/case-file-category';
import { ContentStoreService } from '@app/core/services/content-store.service';
import { CaseComponent } from '@app/modules/case/components/case-base/case.component';
import { CaseService } from '@app/core/services/case.service';
import { TranslationEntryObject } from '@app/shared/models/translatable';
import * as _ from 'lodash-es';
import { TemplateService } from '@app/core/services/template.service';

@Component({
  templateUrl: './case-detailed-attachments.component.html',
  styleUrls: ['./case-detailed-attachments.component.scss']
})
export class CaseDetailedAttachmentsComponent extends CaseComponent
                                              implements OnInit, OnDestroy {

  public fileMetaCategoryList: DrFileMetaCategoryList;
  public acceptedFileTypes: FileType[];

  public documentTypes: TranslationEntryObject[];
  public selectedDocumentType: TranslationEntryObject;

  public selectDocumentType(documentType: TranslationEntryObject): void {
    this.selectedDocumentType = documentType;
  }

  get CaseFileCategory() {
    return CaseFileCategory;
  }

  constructor(
      protected componentServiceBundle: ComponentServiceBundle,
      protected caseService: CaseService,
      protected contentStoreService: ContentStoreService,
      protected templateService: TemplateService
  ) {
    super(componentServiceBundle, caseService);
    this._idPrefix = 'case_detailed_attachments.';
  }

  private orderCaseFileMetaList(): void {
    if (this.fileMetaCategoryList) {
      this.fileMetaCategoryList.sortAllFileMetaDatabyOrder();
    }
  }

  public ngOnInit() {
    super.ngOnInit();
    this.templateService.getSMPDocumentTypes()
                        .subscribe(result => {
       const docTypes = result.map(entry => new TranslationEntryObject(entry));

       this.documentTypes = _.sortBy(docTypes, entry => {
         return this.translateService.instant(entry.actionListDisplayName);
       });

       this.selectDocumentType(this.documentTypes[0]);
    });
  }

  public getDocumentCountForCategory(category: CaseFileCategories): number {
    const fileMetaList = this.fileMetaCategoryList && this.fileMetaCategoryList.getFilesByCategory(category);
    return fileMetaList && fileMetaList.hasItems && fileMetaList.entries.length || 0;
  }

  protected whenOriginalFetched(): void {
    super.whenOriginalFetched();
    this.contentStoreService.getCaseFileMetaList(this.case, CaseFileCategory.ALL.map(cat => cat.key))
        .subscribe((result: DrFileMetaCategoryList) => {
              this.fileMetaCategoryList = result;
              this.orderCaseFileMetaList();
            },
            err => this.handleError(err)
        );
  }

}
